import React from 'react';
import { Button, Col, Row, Space } from 'antd';
import styled from 'styled-components';

type FileExplorerActionsProps = {
  onNextPage?: () => void;
  onPrevPage?: () => void;
  onSubmit?: () => void;
  canNavNextPage?: boolean;
  canNavPrevPage?: boolean;
  canSubmit?: boolean;
  showNavActions?: boolean;
  submitLabel?: string;
  loading?: boolean;
};

const StyledRow = styled(Row)`
  align-items: center;
  justify-content: space-between;
  margin-top: 30px;
  width: 100%;
`;

export function FileExplorerActions({
  onNextPage,
  onPrevPage,
  onSubmit,
  canNavNextPage,
  canNavPrevPage,
  canSubmit,
  loading,
  showNavActions = true,
  submitLabel = 'Add Files',
}: FileExplorerActionsProps) {
  return (
    <StyledRow>
      <Col>
        {showNavActions && (
          <Space>
            <Button onClick={onPrevPage} disabled={!canNavPrevPage || loading}>
              Previous Page
            </Button>
            <Button onClick={onNextPage} disabled={!canNavNextPage || loading}>
              Next Page
            </Button>
          </Space>
        )}
      </Col>
      <Col>
        <Button
          type="primary"
          disabled={!canSubmit || loading}
          onClick={onSubmit}
        >
          {submitLabel}
        </Button>
      </Col>
    </StyledRow>
  );
}
